// sim/casteNames.ts — the CANONICAL caste labels + glyphs for the whole codebase.
//
// One source of truth for the four caste display strings, index-aligned with CASTE.*
// (Worker, Soldier, Flyer, Specialist). The sim, CLI, and web layers all import these
// instead of keeping their own copies, so a renamed/added caste can never drift between
// the compatibility chips, the HUD, and the examples.
//
// Pure data — display only. No sim state, no RNG, never hashed or saved.

import { CASTE_COUNT } from '../types.ts';

/** Short caste names, index-aligned with CASTE.* (Worker, Soldier, Flyer, Specialist). */
export const CASTE_NAME: readonly string[] = ['Worker', 'Soldier', 'Flyer', 'Specialist'];

/** One compact glyph per caste (CASTE.* order), for tight UI chips. */
export const CASTE_GLYPH: readonly string[] = ['⚒', '🛡', '🪽', '🔬'];

// Compile/import-time guard: the label tables must cover exactly the CASTE.* enum, so a
// new caste cannot silently land without a name + glyph (a wrong-length table throws on
// first import — in tests, the CLI, and the web build alike).
if (CASTE_NAME.length !== CASTE_COUNT || CASTE_GLYPH.length !== CASTE_COUNT) {
  throw new Error(
    `casteNames: expected ${CASTE_COUNT} entries, got name=${CASTE_NAME.length} glyph=${CASTE_GLYPH.length}`,
  );
}
